import api from "../utils/api";

// ➕ Add 5 Dummy Teachers
export const addDummyTeachers = () => {
  return api.post("/api/sales/dummy-teacher");
};

// ➕ Add 5 Dummy Students
export const addDummyStudents = () => {
  return api.post("/api/sales/dummy-student");
};

// 📋 Get All Dummy Users
export const getDummyUsers = (role = "") => {
  if (role) {
    return api.get(`/api/sales/dummy-users?role=${role}`);
  }
  return api.get("/api/sales/dummy-users");
};

// 🔐 Impersonate User
export const impersonateUser = (userId) => {
  return api.post(`/api/sales/impersonate/${userId}`);
};

// 🔁 Switch Back to Admin
export const switchBack = () => {
  return api.post("/api/sales/switch-back");
};
// 🗑 Delete All Dummy Users
export const deleteAllDummyUsers = () => {
  return api.delete("/api/sales/dummy-users");
};
export const deleteUser = (userId) => {
  return api.delete(`/api/sales/dummy-user/${userId}`);
};
